export const INTERVIEW_MODAL_TOGGLE = "INTERVIEW_MODAL_TOGGLE";
export const SET_INTERVIEW_REQUEST_DURATION = "SET_INTERVIEW_DURATION";
export const SET_INTERVIEW_REQUEST_STEP = "SET_INTERVIEW_STEP";
export const INTERVIEW_STEP_DURATION = "INTERVIEW_STEP_DURATION";
export const INTERVIEW_STEP_SCHEDULE = "INTERVIEW_STEP_SCHEDULE";
export const INTERVIEW_STEP_REQUEST = "INTERVIEW_STEP_REQUEST";
export const INTERVIEW_STEP_CONFIRMATION = "INTERVIEW_STEP_CONFIRMATION";
export const SET_INTERVIEW_SCHEDULE_TYPE = "SET_INTERVIEW_SCHEDULE_TYPE";

export const HIRE_MODAL_TOGGLE = "HIRE_MODAL_TOGGLE";
export const OFFER_MODAL_TOGGLE = "OFFER_MODAL_TOGGLE";
export const OFFER_STEP_CREATE = "OFFER_STEP_CREATE";
export const OFFER_STEP_VERIFY = "OFFER_STEP_VERIFY";

export const SHARE_MODAL_TOGGLE = "SHARE_MODAL_TOGGLE";
export const ATS_MODAL_TOGGLE = "ATS_MODAL_TOGGLE";
export const MESSAGE_MODAL_TOGGLE = "MESSAGE_MODAL_TOGGLE";
export const PHONE_MODAL_TOGGLE = "PHONE_MODAL_TOGGLE";
export const CONTACTED_MODAL_TOGGLE = "CONTACTED_MODAL_TOGGLE";
export const COLLAPSE_APPLICATION_TOGGLE = "COLLAPSE_APPLICATION_TOGGLE";
export const INTERVIEW_EDIT_MODAL_TOGGLE = "INTERVIEW_EDIT_MODAL_TOGGLE";
export const SWITCH_ACCOUNT_MODAL_TOGGLE = "SWITCH_ACCOUNT_MODAL_TOGGLE";
export const INTERVIEW_ACTIONS_MODAL_TOGGLE = "INTERVIEW_ACTIONS_MODAL_TOGGLE";
export const INTERVIEW_REQUEST_ACTION = "INTERVIEW_REQUEST_ACTION";
export const RESET_INTERVIEW_STEP = "RESET_INTERVIEW_STEP";
export const RESET_INTERVIEW_REQUEST_ACTION = "RESET_INTERVIEW_REQUEST_ACTION";

export const AVAILABILITY_BUFFER_MODAL_TOGGLE =
  "AVAILABILITY_BUFFER_MODAL_TOGGLE";
export const INTERVIEW_FEEDBACK_MODAL_TOGGLE =
  "INTERVIEW_FEEDBACK_MODAL_TOGGLE";

export const INTERVIEW_SCHEDULE_TYPE_AVAILABILITY =
  "INTERVIEW_SCHEDULE_TYPE_AVAILABILITY";
export const INTERVIEW_SCHEDULE_TYPE_SCHEDULED =
  "INTERVIEW_SCHEDULE_TYPE_SCHEDULED";

// interview request action creators
export const interviewModalToggle = (visible) => {
  return {
    type: INTERVIEW_MODAL_TOGGLE,
    value: visible,
  };
};

export const availabilityBufferModalToggle = (visible) => {
  return {
    type: AVAILABILITY_BUFFER_MODAL_TOGGLE,
    value: visible,
  };
};

export const setInterviewDuration = (duration, candidateSlug) => {
  return {
    type: SET_INTERVIEW_REQUEST_DURATION,
    value: duration,
    slug: candidateSlug,
  };
};

export const setInterviewStep = (stepName, candidateSlug) => {
  return {
    type: SET_INTERVIEW_REQUEST_STEP,
    step: stepName,
    slug: candidateSlug,
  };
};

export const setInterviewScheduleType = (scheduleType) => {
  return {
    type: SET_INTERVIEW_SCHEDULE_TYPE,
    value: scheduleType,
  };
};

export const resetInterviewStep = () => {
  return {
    type: RESET_INTERVIEW_STEP,
  };
};

export const hireModalToggle = (visible) => {
  return {
    type: HIRE_MODAL_TOGGLE,
    value: visible,
  };
};

export const offerModalToggle = (visible) => {
  return {
    type: OFFER_MODAL_TOGGLE,
    value: visible,
  };
};

export const shareModalToggle = (visible) => {
  return {
    type: SHARE_MODAL_TOGGLE,
    value: visible,
  };
};

export const atsModalToggle = (visible) => {
  return {
    type: ATS_MODAL_TOGGLE,
    value: visible,
  };
};

export const messageModalToggle = (visible) => {
  return {
    type: MESSAGE_MODAL_TOGGLE,
    value: visible,
  };
};

export const contactedModalToggle = (visible) => {
  return {
    type: CONTACTED_MODAL_TOGGLE,
    value: visible,
  };
};

export const phoneModalToggle = (visible) => {
  return {
    type: PHONE_MODAL_TOGGLE,
    value: visible,
  };
};

export const collapseApplicationToggle = (visible) => {
  return {
    type: COLLAPSE_APPLICATION_TOGGLE,
    value: visible,
  };
};

export const interviewEditModalToggle = (visible) => {
  return {
    type: INTERVIEW_EDIT_MODAL_TOGGLE,
    value: visible,
  };
};

export const switchAccountModalToggle = (visible) => {
  return {
    type: SWITCH_ACCOUNT_MODAL_TOGGLE,
    value: visible,
  };
};

export const setInterviewStepAndToggleEditModal =
  (stepName, candidateSlug, visible) => async (dispatch) => {
    await dispatch(setInterviewStep(stepName, candidateSlug));
    return dispatch(interviewEditModalToggle(visible));
  };

const interviewRequestAction = (actionType) => {
  return {
    type: INTERVIEW_REQUEST_ACTION,
    value: actionType,
  };
};

export const resetInterviewRequestAction = () => {
  return {
    type: RESET_INTERVIEW_REQUEST_ACTION,
  };
};

const interviewActionsModalToggle = (visible) => {
  return {
    type: INTERVIEW_ACTIONS_MODAL_TOGGLE,
    value: visible,
  };
};

export const setInterviewActionsModal =
  (actionType, visible) => async (dispatch) => {
    await dispatch(interviewActionsModalToggle(visible));
    return dispatch(interviewRequestAction(actionType));
  };

export const showFeedbackThankYouModal = (visible) => {
  return {
    type: INTERVIEW_FEEDBACK_MODAL_TOGGLE,
    value: visible,
  };
};
